'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configureLanguage = undefined;

var _utilityFunctions = require('utils/utilityFunctions');

var _languages = require('utils/languages');

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureLanguage = exports.configureLanguage = function configureLanguage(bookingId, bootLang) {
    var userLocale = 'en';

    if ((0, _utilityFunctions.getQueryString)()) {
        userLocale = _qs2.default.parse((0, _utilityFunctions.getQueryString)().replace('?', '')).lang;
    } else if ((0, _utilityFunctions.getLanguageCookie)(bookingId + '-g2g-lang')) {
        userLocale = (0, _utilityFunctions.getLanguageCookie)(bookingId + '-g2g-lang');
    } else if (bootLang) {
        userLocale = bootLang;
    } else {
        userLocale = (0, _utilityFunctions.getBrowserLanguage)();
    }

    if (_languages.allowedLanguages.includes(userLocale)) {
        return {
            userLocale: userLocale
        };
    } else {
        return {
            userLocale: 'en'
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/configureLanguage.js
// module id = 1353
// module chunks = 0